import { LocalizedSmallParagraph } from '@mews-commander/ui';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog, IconName, Stack, SupplementaryIcon } from '@optimus-web/core';

interface SuccessDialogProps {
    onClose: () => void;
    titleTextKey: Mews.TextKey;
    ctaTextKey?: Mews.TextKey;
    descriptionTextKey: Mews.TextKey;
}

export const SuccessDialog = ({
    onClose,
    titleTextKey,
    ctaTextKey = TextKey.Close,
    descriptionTextKey,
}: SuccessDialogProps) => (
    <Dialog
        onClose={onClose}
        active
        size="small"
        title={<LocalizedText textKey={titleTextKey} />}
        footer={{
            primary: (
                <Button onClick={onClose} variant="primary" size="medium" type="submit">
                    <LocalizedText textKey={ctaTextKey} />
                </Button>
            ),
        }}
    >
        <Stack itemAlignment="center" vertical spacing="200">
            <SupplementaryIcon variant="success" value={IconName.Done} />
            <LocalizedSmallParagraph variant="secondary" align="center" textKey={descriptionTextKey} />
        </Stack>
    </Dialog>
);
